//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { ReportProvider } from './components/ReportContext/ReportContext'               ;
import { ControlBox     } from './components/ReportControlBox/ControlBox' ;
import { ReportTable    } from './components/ReportTable/ReportTable'     ;

//#endregion

//-----------------------------------------------------------------
export function ReportPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      backgroundColor: 'var(--bg-color-secondary)',
      padding: '1rem',
      width: '100%',
      display: 'inline-block',
    }
  }

  // === ATTRIBUTES ===
  const
    CONTAINER = {
      sx: _styles.container,
    };


  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <ReportProvider>
          <ControlBox  />
          <ReportTable />
        </ReportProvider>
      </Box>
    );
  }

  //#endregion

  return display();
}
